if (!customElements.get('header-component')) {
  customElements.define(
    'header-component',
    class HeaderComponent extends HTMLElement {
      constructor() {
        super();

        this.style = this.dataset.style;
        this.desktop = this.querySelector('[data-header-desktop]');
        this.deadLinks = document.querySelectorAll('.navlink[href="#"]');
        this.resizeObserver = null;
        this.checkWidth = this.checkWidth.bind(this);
        this.isSticky = this.hasAttribute('data-header-sticky');

        document.body.classList.toggle('has-header-sticky', this.isSticky);
      }

      connectedCallback() {
        this.killDeadLinks();
        this.drawerToggleEvent();
        this.cartToggleEvent();
        this.initSticky();

        if (this.style !== 'drawer' && this.desktop) {
          this.minWidth = this.getMinWidth();
          this.listenWidth();
        }
      }

      listenWidth() {
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.checkWidth);
          this.resizeObserver.observe(this);
        } else {
          document.addEventListener('theme:resize', this.checkWidth);
        }
      }

      drawerToggleEvent() {
        const button = this.querySelector('[data-drawer-toggle]');

        button.addEventListener('click', () => {
          const drawer = document.querySelector('[data-drawer]');

          drawer.dispatchEvent(
            new CustomEvent('theme:drawer:toggle', {
              bubbles: false,
              detail: {
                button: button,
              },
            })
          );
        });
      }

      killDeadLinks() {
        this.deadLinks.forEach((el) => {
          el.onclick = (e) => {
            e.preventDefault();
          };
        });
      }

      checkWidth() {
        if (document.body.clientWidth < 1195) {
          this.classList.add('js__show__mobile');

          // Update --header-height CSS variable when switching to a mobile nav
          const {headerHeight, headerHeightMobile} = window.theme.readHeights();
          document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-mobile', `${headerHeightMobile}px`);
        } else {
          this.classList.remove('js__show__mobile');
        }
      }

      getMinWidth() {
        const comparitor = document.createElement('div');
        comparitor.classList.add('js__header__clone', 'header-wrapper');
        comparitor.appendChild(this.querySelector('header').cloneNode(true));
        document.body.appendChild(comparitor);
        const widthWrappers = comparitor.querySelectorAll('[data-takes-space-wrapper]');
        let minWidth = 0;
        let spaced = 0;

        widthWrappers.forEach((context) => {
          const wideElements = context.querySelectorAll('[data-child-takes-space]');
          let thisWidth = 0;
          if (wideElements.length === 3) {
            thisWidth = this._sumSplitWidths(wideElements);
          } else {
            thisWidth = this._sumWidths(wideElements);
          }
          if (thisWidth > minWidth) {
            minWidth = thisWidth;
            spaced = wideElements.length * 20;
          }
        });

        document.body.removeChild(comparitor);
        return minWidth + spaced;
      }

      cartToggleEvent() {
        if (theme.settings.cartType !== 'drawer') return;

        this.querySelectorAll('[data-cart-toggle]')?.forEach((button) => {
          button.addEventListener('click', (e) => {
            const cartDrawer = document.querySelector('cart-drawer');

            if (cartDrawer) {
              e.preventDefault();
              cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
              window.a11y.lastElement = button;
            }
          });
        });
      }

      initSticky() {
        if (!this.isSticky) return;

        this.isStuck = false;
        this.cls = this.classList;
        this.headerOffset = document.querySelector('.page-header')?.offsetTop;
        this.updateHeaderOffset = this.updateHeaderOffset.bind(this);
        this.scrollEvent = (e) => this.onScroll(e);

        this.listen();
        this.stickOnLoad();
      }

      listen() {
        document.addEventListener('theme:scroll', this.scrollEvent);
        document.addEventListener('shopify:section:load', this.updateHeaderOffset);
        document.addEventListener('shopify:section:unload', this.updateHeaderOffset);
      }

      onScroll(e) {
        if (e.detail.down) {
          if (!this.isStuck && e.detail.position > this.headerOffset) {
            this.stickSimple();
          }
        } else if (e.detail.position <= this.headerOffset) {
          this.unstickSimple();
        }
      }

      updateHeaderOffset(event) {
        if (!event.target.classList.contains('shopify-section-group-header-group')) return;

        // Update header offset after any "Header group" section has been changed
        setTimeout(() => {
          this.headerOffset = document.querySelector('.page-header')?.offsetTop;
        });
      }

      stickOnLoad() {
        if (window.scrollY > this.headerOffset) {
          this.stickSimple();
        }
      }

      stickSimple() {
        this.cls.add('js__header__stuck');
        this.isStuck = true;
      }

      unstickSimple() {
        if (!document.documentElement.hasAttribute('data-scroll-locked')) {
          // check for scroll lock
          this.cls.remove('js__header__stuck');
          this.isStuck = false;
        }
      }

      _sumSplitWidths(nodes) {
        let arr = [];
        nodes.forEach((el) => {
          if (el.firstElementChild) {
            arr.push(el.firstElementChild.clientWidth);
          }
        });
        if (arr[0] > arr[2]) {
          arr[2] = arr[0];
        } else {
          arr[0] = arr[2];
        }
        const width = arr.reduce((a, b) => a + b);
        return width;
      }

      _sumWidths(nodes) {
        let width = 0;
        nodes.forEach((el) => {
          width += el.clientWidth;
        });
        return width;
      }

      disconnectedCallback() {
        if ('ResizeObserver' in window) {
          this.resizeObserver?.unobserve(this);
        } else {
          document.removeEventListener('theme:resize', this.checkWidth);
        }

        if (this.isSticky) {
          document.removeEventListener('theme:scroll', this.scrollEvent);
          document.removeEventListener('shopify:section:load', this.updateHeaderOffset);
          document.removeEventListener('shopify:section:unload', this.updateHeaderOffset);
        }
      }
    }
  );
}
